import { render, RenderOptions, RenderResult } from '@testing-library/react';
import React from 'react';
import { MemoryRouter } from 'react-router-dom';

if (typeof jest !== 'undefined') {
  jest.mock('react-i18next', () => ({
    useTranslation: () => {
      return {
        t: (str: string) => str,
        i18n: {
          changeLanguage: () => new Promise((): undefined => undefined),
        },
      };
    },
  }));
}

const Providers: React.FC<{ children: React.ReactNode }> = ({ children }: { children: React.ReactNode }): JSX.Element => {
  return (
    <MemoryRouter>
      {children}
    </MemoryRouter>
  );
};

const customRender = (ui: JSX.Element, options?: RenderOptions) => {
  const rendered: RenderResult = render(
    ui,
    { wrapper: Providers, ...options },
  );

  return {
    ...rendered,
    rerender: (
      uiItem: JSX.Element, optionsItem?: RenderOptions,
    ) => customRender(uiItem, { container: rendered.container, ...optionsItem }),
  };
};

// re-export everything
export * from '@testing-library/react';

export { customRender as render };
// override render method
